// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-transform-button:focus{outline:0}.rselected{border-width:2px;--border-opacity:1;border-color:#90cdf4;border-color:rgba(144,205,244,var(--border-opacity));box-sizing:border-box}.notrselected,.rselected{margin-left:.25rem;margin-right:.25rem}.blank-transform{min-height:4rem;height:4rem;--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}", ""]);
// Exports
module.exports = exports;
